var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.248,
    height: 18,
    viewBox: "0 0 20.248 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_83",
    "data-name": "Union 83",
    d: "M3608.69-22437a1.818,1.818,0,0,1-1.69-1.934v-10.277a1.827,1.827,0,0,1,1.69-1.934h.557v8.363a3.039,3.039,0,0,0,2.816,3.211h11.811v.637a1.817,1.817,0,0,1-1.689,1.934Zm3.374-3.863a1.81,1.81,0,0,1-1.69-1.918v-10.289a1.821,1.821,0,0,1,1.69-1.93h13.5a1.821,1.821,0,0,1,1.684,1.93v10.289a1.809,1.809,0,0,1-1.684,1.918Z",
    transform: "translate(-3607 22455.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.2f03f35882f0ed5412c521d639e182f9.svg";
export { ForwardRef as ReactComponent };